import { useCallback } from 'react';
import { api } from '../api/client';

export function useReport() {
  const downloadDetailed = useCallback((from: string, to: string) => {
    api.downloadCsv('/reports/csv/detailed', { from, to });
  }, []);

  const downloadSynthesis = useCallback((from: string, to: string) => {
    api.downloadCsv('/reports/csv/synthesis', { from, to });
  }, []);

  return { downloadDetailed, downloadSynthesis };
}
